import React from "react";
import { GenericCroutonProps, OverlayType, RegisterOverlaysArgs, ShowCroutonArgs } from "@swiggy-private/cart-types";

export interface CartOverlaysContextValue {
    registerCrouton: (props: ShowCroutonArgs) => void;
    shouldRenderCrouton: boolean;
    onCloseCrouton: () => void;
    croutonContent: GenericCroutonProps | null;
    subscribeToCroutonContent: (listener: () => void) => () => void;
    getCroutonContentSnapshot: () => GenericCroutonProps | null;
    registerOverlays: (props: RegisterOverlaysArgs) => void;
    enabledOverlayId: string;
    enabledCroutonId: string;
    enabledOverlayType: OverlayType | null;
    onCloseOverlay: () => void;
    onCloseOverlayImmediate: () => void;
    onCloseCroutonImmediate: () => void;
}

export const CartOverlaysContext = React.createContext<CartOverlaysContextValue>({
    registerCrouton: () => void 0,
    shouldRenderCrouton: false,
    onCloseCrouton: () => void 0,
    croutonContent: null,
    subscribeToCroutonContent: () => () => void 0,
    getCroutonContentSnapshot: () => null,
    registerOverlays: () => void 0,
    enabledOverlayId: "",
    enabledCroutonId: "",
    enabledOverlayType: null,
    onCloseOverlay: () => void 0,
    onCloseOverlayImmediate: () => void 0,
    onCloseCroutonImmediate: () => void 0,
});

if (__DEV__) {
    CartOverlaysContext.displayName = "CartOverlaysContext";
}
